import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressionPanel = ({ userProgress }) => {
  const milestoneProgress = (userProgress?.totalPoints / userProgress?.nextMilestone) * 100;

  return (
    <div className="bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl p-6 md:p-8 mb-8 shadow-xl">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="TrendingUp" size={24} className="text-white" />
        <h2 className="text-xl md:text-2xl font-bold text-white">
          Votre Progression d'Exploration
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {/* Total Points */}
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Zap" size={20} className="text-amber-300" />
            <span className="text-sm text-white/80">Points Totaux</span>
          </div>
          <p className="text-3xl font-bold text-white">{userProgress?.totalPoints}</p>
        </div>

        {/* Exploration Level */}
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Award" size={20} className="text-blue-300" />
            <span className="text-sm text-white/80">Niveau</span>
          </div>
          <p className="text-3xl font-bold text-white">{userProgress?.explorationLevel}</p>
          <p className="text-xs text-white/60 mt-1">Explorateur Actif</p>
        </div>

        {/* Fields Unlocked */}
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Unlock" size={20} className="text-green-300" />
            <span className="text-sm text-white/80">Domaines Débloqués</span>
          </div>
          <p className="text-3xl font-bold text-white">
            {userProgress?.fieldsUnlocked}/{userProgress?.totalFields}
          </p>
        </div>

        {/* Completed Discoveries */}
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="CheckCircle" size={20} className="text-purple-300" />
            <span className="text-sm text-white/80">Explorations Complètes</span>
          </div>
          <p className="text-3xl font-bold text-white">{userProgress?.completedDiscoveries}</p>
        </div>
      </div>

      {/* Next Milestone Progress */}
      <div className="mt-6 bg-white/10 backdrop-blur-md rounded-xl p-5 border border-white/20">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Icon name="Target" size={20} className="text-white" />
            <span className="text-sm font-medium text-white">Prochain Jalon</span>
          </div>
          <span className="text-sm text-white/80">
            {userProgress?.totalPoints} / {userProgress?.nextMilestone} points
          </span>
        </div>
        <div className="w-full h-3 bg-white/20 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-amber-400 to-amber-500 transition-all duration-500 rounded-full"
            style={{ width: `${milestoneProgress}%` }}
          />
        </div>
        <p className="text-xs text-white/70 mt-2">
          Encore {userProgress?.pointsToNextMilestone} points pour débloquer le badge "Chercheur de Carrière"
        </p>
      </div>
    </div>
  );
};

export default ProgressionPanel;